module.exports = __webpack_public_path__ + "static/media/icoSuccess-1.bb149513.svg";